import React, { useEffect, useState } from "react";

import "../MenuList/MenuList.css";
import "./ListaPedido.css";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { Header1 } from "../../componentes/header/Header1";
import PopUpEntrega from "../TipoEntrega/PopUpEntrega";
import iconsCart from "../../Imagenes/icons_cart_while.svg";
import { configShop } from '../../states/configShop';
import { userOrder } from '../../states/userOrder';
import { apiPost } from '../../utils/api';
import { ToastContainer, toast } from 'react-toastify';
import { CarrionGroup } from "../../componentes/CarruselCategorias/CarrionGroup";
import { FaArrowLeft, FaPlus, FaMinus, FaShoppingBag } from "react-icons/fa";

export const ListaPedido = ({
  codigoCurrency,
  codigoPais,
}) => {
  const { dataConfig } = configShop();
  const [lista, setLista] = useState([]);
  const [precioTotal, setPrecioTotal] = useState(0);
  const { dataUser } = userOrder();
  const [preOrden, setPreOrden] = useState([]);
  const navigate = useNavigate();

  const brand = dataConfig?.color_botton;
  const brandText = dataConfig?.color_button_text;

  useEffect(() => {
    obtenerProductos();
  }, []);

  useEffect(() => {
    CalcularValor();
  }, []);

  const obtenerPrecioProducto = (producto) => {
    var precioTopping = 0;
    if (producto.toppings !== undefined) {
      producto.toppings.map((item) => {
        if (item.topingsSeleccionados !== undefined) {
          item.topingsSeleccionados.map((topping) => {
            precioTopping += topping.price;
          });
        }
      });
    }
    return (producto.precio + precioTopping) * producto.cantidadProducto;
  };

  const obtenerProductos = () => {
    const raw = localStorage.getItem("infoProductoSeleccionado");
    if (raw !== undefined && raw !== null) {
      const parsed = JSON.parse(raw);
      let total = 0;
      parsed.map((item) => { total += obtenerPrecioProducto(item); });
      setPrecioTotal(total);
      setLista(parsed);
    } else {
      setLista([]);
    }
  };

  const agregarProducto = (index) => {
    lista[index].cantidadProducto += 1;
    localStorage.setItem("infoProductoSeleccionado", JSON.stringify(lista));
    obtenerProductos();
  };

  const restarProducto = (index) => {
    if (lista[index].cantidadProducto > 1) {
      lista[index].cantidadProducto -= 1;
    } else {
      lista.splice(index, 1);
    }
    localStorage.setItem("infoProductoSeleccionado", JSON.stringify(lista));
    obtenerProductos();
  };

  const borrarCarrito = (e) => {
    e.preventDefault();
    localStorage.removeItem("infoProductoSeleccionado");
    setPrecioTotal(0);
    setLista([]);
  };

  const informacionProdSelecs = () => {
    let arrayToppings = [];
    let infoProductoSeleccionado = JSON.parse(localStorage.getItem("infoProductoSeleccionado"));
    infoProductoSeleccionado.map((item) => {
      var listaToppings = [];
      item.toppings.map((t) => {
        t.topingsSeleccionados.map((s) => {
          listaToppings.push({ uuid_toppings: s.uuid, quantity: "1" });
        });
      });
      arrayToppings.push({
        uuid_product: item.idPlatoSelec,
        quantity: item.cantidadProducto,
        observations: "",
        toppings: listaToppings,
      });
    });
    return arrayToppings;
  };

  const CalcularValor = async () => {
    let metodoPago = localStorage.getItem("Metodo de pago");
    let uuid_address = localStorage.getItem("uuid_address");
    let arrayListaProductos = informacionProdSelecs();
    try {
      const res = await apiPost('/pre-orders-app-v2', {
        guests: dataUser,
        uuid_address,
        delivery_type: dataUser.deliveryMethod,
        payment_method_id: metodoPago,
        product: arrayListaProductos,
      });
      if (res.success === "success") {
        setPreOrden(res.data);
      } else {
        toast.error(res.message, {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          theme: "light",
        });
      }
    } catch (err) {
      console.log(err);
    }
  };

  const btnColor   = dataConfig?.page_menu?.button?.color       ?? "#000";
  const btnText    = dataConfig?.page_menu?.button?.color_text  ?? "#fff";

  const propiedadesCompany = dataConfig;

  const pasaAlDetallePago = () => navigate("/RegistroGuests");
  const colorTitle = dataConfig?.page_menu?.color_text          ?? dataConfig?.color_font ?? "#111";
  const colorSub   = dataConfig?.page_menu?.color_description   ?? dataConfig?.color_font_secundary ?? "#888";
  const colorPrice = dataConfig?.page_menu?.color_price         ?? dataConfig?.color_font ?? "#111";

  return (
    <div className="App">
      <div className="container-principal-carrito">
        <header className="App-header">
          <Header1 propiedadesCompany={propiedadesCompany} />
        </header>

        {/* Título */}
        <div style={{ padding: "12px 20px 4px", display: "flex", alignItems: "center", gap: "8px" }}>
          <FaShoppingBag color={btnColor} size={20} />
          <h2 style={{ margin: 0, fontSize: "18px", fontWeight: 700, color: colorTitle }}>
            Mi pedido
            <span style={{ fontSize: "13px", fontWeight: 400, color: colorSub, marginLeft: "6px" }}>
              ({lista.length} {lista.length === 1 ? "producto" : "productos"})
            </span>
          </h2>
        </div>

        <div className="container-list-pedido" style={{ paddingBottom: "120px" }}>
          {lista.map((item, index) => (
            <React.Fragment key={item.idPlatoSelec}>
              <div style={{
                display: "flex",
                gap: "12px",
                alignItems: "center",
                padding: "14px 20px",
                borderBottom: "1px solid #F0F0F0",
              }}>
                {/* Foto */}
                <div style={{ position: "relative", flexShrink: 0 }}>
                  <img
                    src={item.fotoPlatoSelec}
                    alt={item.nombrePlatoSelec}
                    style={{ width: "72px", height: "72px", borderRadius: "10px", objectFit: "cover", display: "block" }}
                  />
                  <span style={{
                    position: "absolute", top: "-6px", right: "-6px",
                    background: btnColor, color: btnText,
                    borderRadius: "50%", width: "20px", height: "20px",
                    fontSize: "11px", fontWeight: 700,
                    display: "flex", alignItems: "center", justifyContent: "center",
                  }}>
                    {item.cantidadProducto}
                  </span>
                </div>

                {/* Info */}
                <div style={{ flex: 1, minWidth: 0 }}>
                  <p style={{ margin: 0, fontWeight: 700, fontSize: "14px", color: colorTitle, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                    {item.nombrePlatoSelec}
                  </p>
                  {item.toppings.map((topping, i) =>
                    topping.topingsSeleccionados.map((s, j) => (
                      <p key={`${i}-${j}`} style={{ margin: 0, fontSize: "12px", color: colorSub }}>
                        · {s.name} {s.price > 0 && `+${s.price.toLocaleString(codigoPais, { style: "currency", minimumFractionDigits: 0, maximumFractionDigits: 0, currency: codigoCurrency })}`}
                      </p>
                    ))
                  )}
                </div>

                {/* Precio + controles */}
                <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: "8px", flexShrink: 0 }}>
                  <span style={{ fontWeight: 700, fontSize: "14px", color: colorPrice }}>
                    {obtenerPrecioProducto(item).toLocaleString(codigoPais, { style: "currency", minimumFractionDigits: 0, maximumFractionDigits: 0, currency: codigoCurrency })}
                  </span>
                  <div style={{ display: "flex", alignItems: "center", gap: "10px", border: `1.5px solid ${btnColor}`, borderRadius: "8px", padding: "4px 10px" }}>
                    <span onClick={() => restarProducto(index)} style={{ fontSize: "18px", fontWeight: 700, color: btnColor, cursor: "pointer", lineHeight: 1, userSelect: "none" }}>−</span>
                    <span style={{ fontSize: "14px", fontWeight: 600, minWidth: "16px", textAlign: "center", color: colorTitle }}>{item.cantidadProducto}</span>
                    <span onClick={() => agregarProducto(index)} style={{ fontSize: "18px", fontWeight: 700, color: btnColor, cursor: "pointer", lineHeight: 1, userSelect: "none" }}>+</span>
                  </div>
                </div>
              </div>
            </React.Fragment>
          ))}

          {/* Footer fijo */}
          <div style={{
            position: "fixed", bottom: 0, left: 0, width: "100%",
            background: "#fff", borderRadius: "20px 20px 0 0",
            boxShadow: "0 -4px 20px rgba(0,0,0,0.10)",
            padding: "12px 16px 22px", zIndex: 1000,
          }}>
            {preOrden?.Recomendados?.length > 0 && (
              <CarrionGroup openCategories={preOrden.Recomendados} title="Para acompañar tu pedido" />
            )}

            {/* Resumen de precios */}
            {preOrden?.base_value > 0 && (
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "6px", padding: "0 4px" }}>
                <span style={{ fontSize: "13px", color: colorSub }}>Subtotal</span>
                <span style={{ fontSize: "13px", color: colorTitle }}>
                  {preOrden.base_value.toLocaleString(codigoPais, { style: "currency", minimumFractionDigits: 0, maximumFractionDigits: 0, currency: codigoCurrency })}
                </span>
              </div>
            )}
            {preOrden?.delivery_value > 0 && (
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "6px", padding: "0 4px" }}>
                <span style={{ fontSize: "13px", color: colorSub }}>Domicilio</span>
                <span style={{ fontSize: "13px", color: colorTitle }}>
                  {preOrden.delivery_value.toLocaleString(codigoPais, { style: "currency", minimumFractionDigits: 0, maximumFractionDigits: 0, currency: codigoCurrency })}
                </span>
              </div>
            )}

            {/* Botón pagar */}
            <button
              onClick={() => pasaAlDetallePago()}
              style={{
                width: "100%", background: btnColor, color: btnText,
                border: "none", borderRadius: "14px", padding: "14px 20px",
                display: "flex", alignItems: "center", justifyContent: "space-between",
                boxShadow: "0 4px 20px rgba(0,0,0,0.22)", cursor: "pointer", marginTop: "6px",
              }}
            >
              <span style={{ fontSize: "16px", fontWeight: 700 }}>Continuar</span>
              <span style={{ fontSize: "16px", fontWeight: 700 }}>
                {precioTotal.toLocaleString(codigoPais, { style: "currency", minimumFractionDigits: 0, maximumFractionDigits: 0, currency: codigoCurrency })}
              </span>
            </button>
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};
